function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { connect } from 'react-redux';
import DeleteWarning from "../../general/DeleteWarning";
import { closeSecondLayerModal } from "../../../../redux/ui/modal/modalActions";

class TmDeleteField extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "handleDelete", () => {
      this.props.closeSecondLayerModal();
      this.props.onClear();
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(DeleteWarning, {
        onDelete: this.handleDelete
      });
    });
  }

}

export default connect(null, {
  closeSecondLayerModal
})(TmDeleteField);